// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9148","video":"_6696","cover":"_3801","play":"_8581"};